import { defineMessages } from 'react-intl';

export default defineMessages({
  subscribe: {
    id: 'cboard.components.Settings.Subscribe.subscribe',
    defaultMessage: 'Subscribe'
  },
  includedFeatures: {
    id: 'cboard.components.Settings.Subscribe.includedFeatures',
    defaultMessage: 'Included features:'
  },
  onlineNeuralVoices: {
    id: 'cboard.components.Settings.Subscribe.onlineNeuralVoices',
    defaultMessage: 'Online neural voices'
  },
  copyPublicBoards: {
    id: 'cboard.components.Settings.Subscribe.copyPublicBoards',
    defaultMessage: 'Copy public boards'
  },
  publishBoards: {
    id: 'cboard.components.Settings.Subscribe.publishBoards',
    defaultMessage: 'Publish boards'
  },
  copyTiles: {
    id: 'cboard.components.Settings.Subscribe.copyTiles',
    defaultMessage: 'Copy tiles'
  },
  pasteTiles: {
    id: 'cboard.components.Settings.Subscribe.pasteTiles',
    defaultMessage: 'Paste tiles'
  },
  powerfulUsageAnalytics: {
    id: 'cboard.components.Settings.Subscribe.powerfulUsageAnalytics',
    defaultMessage: 'Powerful usage analytics'
  },
  shareBoards: {
    id: 'cboard.components.Settings.Subscribe.shareBoards',
    defaultMessage: 'Share boards'
  },
  adsFree: {
    id: 'cboard.components.Settings.Subscribe.adsFree',
    defaultMessage: 'Ads free'
  },
  exportToOpenBoardFormat: {
    id: 'cboard.components.Settings.Subscribe.exportToOpenBoardFormat',
    defaultMessage: 'Export to open board format (OBF)'
  },
  sharePhrases: {
    id: 'cboard.components.Settings.Subscribe.sharePhrases',
    defaultMessage: 'Share phrases'
  },
  privateSupportChannel: {
    id: 'cboard.components.Settings.Subscribe.privateSupportChannel',
    defaultMessage: 'Private support channel'
  },
  voiceRecordingForTiles: {
    id: 'cboard.components.Settings.Subscribe.voiceRecordingForTiles',
    defaultMessage: 'Voice recording for tiles'
  },
  active: {
    id: 'cboard.components.Settings.Subscribe.active',
    defaultMessage: 'ACTIVE'
  },
  canceled: {
    id: 'cboard.components.Settings.Subscribe.canceled',
    defaultMessage: 'CANCELED'
  },
  in_grace_period: {
    id: 'cboard.components.Settings.Subscribe.in_grace_period',
    defaultMessage: 'GRACE PERIOD'
  },
  proccesing: {
    id: 'cboard.components.Settings.Subscribe.processing',
    defaultMessage: 'We are processing your subscription...'
  },
  expired: {
    id: 'cboard.components.Settings.Subscribe.expired',
    defaultMessage: 'Your subscription expired on: {e}'
  },
  paused: {
    id: 'cboard.components.Settings.Subscribe.paused',
    defaultMessage: 'Your subscription was paused on: {e}'
  },
  on_hold: {
    id: 'cboard.components.Settings.Subscribe.on_hold',
    defaultMessage: 'Your subscription expired on: {e}'
  },
  not_subscribed: {
    id: 'cboard.components.Settings.Subscribe.not_subscribed',
    defaultMessage: 'You are not subscribed. '
  },
  unverified: {
    id: 'cboard.components.Settings.Subscribe.unverified',
    defaultMessage:
      'An error occurred during validation of your purchase. Please refresh'
  },
  refresh: {
    id: 'cboard.components.Settings.Subscribe.refresh',
    defaultMessage: 'Refresh'
  },
  error: {
    id: 'cboard.components.Settings.Subscribe.error',
    defaultMessage: 'Oops something went wrong. Please try again later'
  },
  empty_product: {
    id: 'cboard.components.Settings.Subscribe.empty_product',
    defaultMessage:
      'There are no subscription available at this moment. Please try again later.'
  },
  on_trial_period: {
    id: 'cboard.components.Settings.Subscribe.on_trial_period',
    defaultMessage:
      'You are on the 15 day free trial. After it ends, you will need to subscribe to get all features.'
  },
  subscriptionInfo: {
    id: 'cboard.components.Settings.Subscribe.subscriptionInfo',
    defaultMessage: 'Subscription Info'
  },
  manageSubscription: {
    id: 'cboard.components.Settings.Subscribe.manageSubscription',
    defaultMessage: 'Manage Subscription'
  },
  cancelSubscription: {
    id: 'cboard.components.Settings.Subscribe.cancelSubscription',
    defaultMessage: 'Cancel Subscription'
  },
  planAmount: {
    id: 'cboard.components.Settings.Subscribe.planAmount',
    defaultMessage: 'Plan amount:'
  },
  title: {
    id: 'cboard.components.Settings.Subscribe.title',
    defaultMessage: 'Plan:'
  },
  status: {
    id: 'cboard.components.Settings.Subscribe.status',
    defaultMessage: 'Status:'
  },
  nextPayment: {
    id: 'cboard.components.Settings.Subscribe.nextPayment',
    defaultMessage: 'Next payment at:'
  },
  premiumWillEnd: {
    id: 'cboard.components.Settings.Subscribe.premiumWillEnd',
    defaultMessage: 'The premium acces will end on:'
  },
  fixPaymentIssue: {
    id: 'cboard.components.Settings.Subscribe.fixPaymentIssue',
    defaultMessage: 'Fix your payment issues before the:'
  },
  googleAccountAlreadyOwns: {
    id: 'cboard.components.Settings.Subscribe.googleAccountAlreadyOwns',
    defaultMessage:
      'It looks like your Google account has already purchased a product. Try restarting the app.'
  },
  appleAccountAlreadyOwns: {
    id: 'cboard.components.Settings.Subscribe.appleAccountAlreadyOwns',
    defaultMessage:
      'It looks like your Apple account has already purchased a product. Try restarting the app.'
  },
  fallback: {
    id: 'cboard.components.Settings.Subscribe.fallback',
    defaultMessage: 'Wait please...'
  },
  close: {
    id: 'cboard.components.Settings.Subscribe.close',
    defaultMessage: 'Close'
  },
  cancelSubscriptionDescription: {
    id: 'cboard.components.Settings.Subscribe.cancelSubscriptionDescription',
    defaultMessage: 'Are you sure you want to cancel your current plan?'
  },
  canceledSubscriptionOk: {
    id: 'cboard.components.Settings.Subscribe.canceledSubscriptionOk',
    defaultMessage: 'Your subscription was cancelled successfully.'
  },
  canceledSubscriptionError: {
    id: 'cboard.components.Settings.Subscribe.canceledSubscriptionError',
    defaultMessage:
      'There was an error cancelling your subscription, please try again in a moment.'
  }
});
